'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _values = require('babel-runtime/core-js/object/values');

var _values2 = _interopRequireDefault(_values);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _fetchEverywhere = require('fetch-everywhere');

var _fetchEverywhere2 = _interopRequireDefault(_fetchEverywhere);

var _getNested = require('get-nested');

var _getNested2 = _interopRequireDefault(_getNested);

var _mobx = require('mobx');

var _Form = require('../Observables/Form');

var _Form2 = _interopRequireDefault(_Form);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function composeLookUp(LookUpComponent) {
  var _class, _temp;

  return _temp = _class = function (_Component) {
    (0, _inherits3.default)(_class, _Component);

    function _class(props) {
      (0, _classCallCheck3.default)(this, _class);

      var _this = (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, _getPrototypeOf2.default)(_class)).call(this, props));

      _this.formKeySuffix = '-' + props.field['#webform_key'];

      /**
       * Example: {
       *  street: {
       *    formKey: 'street', // #webform_key in Drupal
       *    apiValue: response => response.street, // Method that receives the response object, and returns the value to pre-fill or false if not to pre-fill.
       *    hideField: true, // Boolean to determine default state of field.
       *    triggerLookUp: false, // Boolean to determine whether blurring this field should trigger the look-up.
       *  },
       * }
       */
      _this.lookUpFields = {};

      _this.lookUpOnBlurOnly = false;

      _this.lookUpBase = null;
      _this.el = null;

      _this.state = {
        query: ''
      };

      _this.onChange = _this.onChange.bind(_this);
      _this.onBlur = _this.onBlur.bind(_this);
      _this.onMount = _this.onMount.bind(_this);
      _this.getField = _this.getField.bind(_this);
      _this.getState = _this.getState.bind(_this);
      _this.fieldIterator = _this.fieldIterator.bind(_this);
      _this.triggerLookUp = _this.triggerLookUp.bind(_this);
      _this.registerLookUp = _this.registerLookUp.bind(_this);
      return _this;
    }

    (0, _createClass3.default)(_class, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        this.setFieldVisibility(true);
        this.setManualOverride(false);
      }
    }, {
      key: 'onMount',
      value: function onMount(el) {
        if (el) {
          this.el = el;
          this.lookUpBase = el.lookUpBase;
          this.lookUpFields = el.lookUpFields || {};
        }
      }
    }, {
      key: 'onBlur',
      value: function onBlur(e) {
        var triggerElement = (0, _values2.default)(this.lookUpFields).find(function (element) {
          return element.formKey === e.target.name;
        });
        if (!triggerElement || !triggerElement.triggerLookUp) {
          return;
        }

        this.triggerLookUp();

        this.props.onBlur(e);
      }
    }, {
      key: 'onChange',
      value: function onChange(e) {
        var triggerElement = (0, _values2.default)(this.lookUpFields).find(function (element) {
          return element.formKey === e.target.name;
        });
        if (triggerElement && !triggerElement.triggerLookUp) {
          this.setManualOverride(true);
        }
        this.props.onChange(e);

        if (!triggerElement || this.lookUpOnBlurOnly) return;

        var field = this.props.formStore.getField(triggerElement.formKey);

        if (!field) return;

        var lookUpKey = this.el.getLookUpKey();
        var lookUp = (0, _mobx.get)(field.lookUps, lookUpKey);
        if (lookUp && lookUp.lookUpSent) this.triggerLookUp();
      }
    }, {
      key: 'setFieldVisibility',
      value: function setFieldVisibility() {
        var lookUpKey = this.el.getLookUpKey();
        this.fieldIterator(function (field, element) {
          var lookUp = (0, _mobx.get)(field.lookUps, lookUpKey);
          if (lookUp) {
            (0, _mobx.set)(field.lookUps, lookUpKey, (0, _extends3.default)({}, lookUp, {
              lookUpHide: !!element.hideField,
              lookUpDisabled: !!element.disableField
            }));
          }
        });
      }
    }, {
      key: 'setManualOverride',
      value: function setManualOverride(override) {
        var _getField = this.getField('manualOverride'),
            field = _getField.field;

        if (field) {
          field.value = override.toString();
        }
      }

      /**
       * @param elementKey
       * @returns {Boolean | {field: Field, element}}
       */

    }, {
      key: 'getField',
      value: function getField(elementKey) {
        if (!this.lookUpFields) {
          return false;
        }
        var element = this.lookUpFields[elementKey];
        if (!element) {
          return false;
        }
        var field = this.props.formStore.getField(element.formKey);
        return {
          element: element,
          field: field
        };
      }
    }, {
      key: 'getFields',
      value: function getFields() {
        var _this2 = this;

        if (!this.lookUpFields) {
          return [];
        }
        return (0, _values2.default)(this.lookUpFields).map(function (element) {
          return _this2.props.formStore.getField(element.formKey);
        });
      }
    }, {
      key: 'getState',
      value: function getState() {
        return this.state;
      }
    }, {
      key: 'registerLookUp',
      value: function registerLookUp(lookUpKey, lookUpFields) {
        var lookUpOnBlurOnly = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

        this.lookUpFields = lookUpFields;
        this.lookUpOnBlurOnly = lookUpOnBlurOnly;
        this.fieldIterator(function (field, element) {
          (0, _mobx.set)(field.lookUps, lookUpKey, {
            lookUpSent: false,
            lookUpSuccessful: true,
            lookUpHide: element.lookUps,
            lookUpDisabled: false
          });
        });
      }
    }, {
      key: 'triggerLookUp',
      value: function triggerLookUp() {
        var fields = {};
        this.fieldIterator(function (field, element) {
          var value = field.value;
          if (!field.empty) {
            fields[element.elementKey] = value;
          }
        });

        var lookUpObject = this.el.prepareLookUp ? this.el.prepareLookUp(fields) : false;
        if (lookUpObject && lookUpObject.query !== this.state.query) {
          this.lookUp(lookUpObject);
        }
      }
    }, {
      key: 'fieldIterator',
      value: function fieldIterator(cb) {
        var _this3 = this;

        var stop = false;
        if (!this.lookUpFields) {
          return false;
        }
        (0, _keys2.default)(this.lookUpFields).forEach(function (elementKey) {
          if (stop === true) {
            return;
          }

          var _getField2 = _this3.getField(elementKey),
              element = _getField2.element,
              field = _getField2.field;

          if (field) {
            stop = cb(field, element) === false;
          }
        });
        return true;
      }
    }, {
      key: 'lookUp',
      value: function lookUp(request) {
        var _this4 = this;

        var query = request.query,
            _request$headers = request.headers,
            headers = _request$headers === undefined ? {} : _request$headers;

        this.setState({ query: query });

        // eslint-disable-next-line no-undef
        var headersObject = new Headers(headers);

        (0, _fetchEverywhere2.default)('' + this.lookUpBase + query, {
          headers: headersObject
        }).then(function (res) {
          return res.json();
        }).then(function (response) {
          return _this4.processResponse(response, request);
        }).catch(function (response) {
          return _this4.processResponse(response, request);
        });
      }
    }, {
      key: 'processResponse',
      value: function processResponse(jsonResponse, _ref) {
        var _this5 = this;

        var query = _ref.query,
            _ref$checkResponse = _ref.checkResponse,
            checkResponse = _ref$checkResponse === undefined ? function () {
          return false;
        } : _ref$checkResponse,
            _ref$isSuccessful = _ref.isSuccessful,
            isSuccessful = _ref$isSuccessful === undefined ? function () {
          return true;
        } : _ref$isSuccessful;

        if (this.state.query !== query) {
          console.warn('A lookUp query was returned, but we already fired another one. Ignoring this result.', query, jsonResponse);
          return;
        }

        var response = checkResponse(jsonResponse);
        var successful = isSuccessful(response);

        var lookUpKey = this.el.getLookUpKey();
        var lookUpField = this.props.formStore.getField(this.props.field['#webform_key']);

        (0, _mobx.set)(lookUpField.lookUps, lookUpKey, (0, _extends3.default)({}, (0, _mobx.get)(lookUpField.lookUps, lookUpKey), {
          lookUpSent: true,
          lookUpSuccessful: successful
        }));

        // Let every field know the lookUp was sent, and if it was successful
        (0, _keys2.default)(this.lookUpFields).forEach(function (elementKey) {
          var _getField3 = _this5.getField(elementKey),
              field = _getField3.field;

          if (field) {
            (0, _mobx.set)(field.lookUps, lookUpKey, (0, _extends3.default)({}, (0, _mobx.get)(field.lookUps, lookUpKey), {
              lookUpSent: true,
              lookUpSuccessful: successful
            }));
          }
        });

        this.fieldIterator(function (field, element) {
          var value = (0, _getNested2.default)(function () {
            return element.apiValue(response);
          });
          if (value) {
            field.value = value;
            field.isBlurred = true;
          }
        });

        this.setManualOverride(!successful); // If successful, set to false since values are overridden

        if (this.el.lookUpCallback) {
          this.el.lookUpCallback(response);
        }
      }
    }, {
      key: 'render',
      value: function render() {
        return _react2.default.createElement(LookUpComponent, (0, _extends3.default)({}, this.props, this.state, {
          onBlur: this.onBlur,
          onChange: this.onChange,
          ref: this.onMount,
          formKeySuffix: this.formKeySuffix,
          fieldIterator: this.fieldIterator,
          getField: this.getField,
          getState: this.getState,
          fields: this.getFields(),
          registerLookUp: this.registerLookUp
        }));
      }
    }]);
    return _class;
  }(_react.Component), _class.meta = LookUpComponent.meta || {}, _class.propTypes = {
    formStore: _propTypes2.default.instanceOf(_Form2.default).isRequired,
    field: _propTypes2.default.shape({
      '#webform_key': _propTypes2.default.string.isRequired,
      composite_elements: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        '#webform_key': _propTypes2.default.string.isRequired,
        '#default_value': _propTypes2.default.string
      }))
    }).isRequired,
    onBlur: _propTypes2.default.func.isRequired,
    onChange: _propTypes2.default.func.isRequired
  }, _class.rewriteValue = LookUpComponent.rewriteValue, _temp;
}

exports.default = composeLookUp;